<template>
  <div class="jc-center">
    <div class="content">
      <h1>近期动态</h1>
      <div class="flex">
        <div class="box-content">
          <div class="flex jc-sb mb30">
            <div class="fz20">公司新闻</div>
            <div class="fz12 cp">更多 »</div>
          </div>
          <a
            v-for="(item, index) in list"
            :key="index"
            class="mb20 flex cp"
            v-if="index < 4"
          >
            <img :src="item.schoolPageInfo.poster" />
            <div>
              <div class="fz16 mb10 color-gray-10 bolder ellipsis ta-left">
                {{ item.schoolPageInfo.title }}
              </div>
              <div class="color-gray-7 fz14 ta-left">
                {{ item.schoolPageInfo.content }}
              </div>
            </div>
          </a>
        </div>
        <div class="box-content">
          <div class="flex jc-sb mb30">
            <div class="fz20">行业动态</div>
            <div class="fz12 cp">更多 »</div>
          </div>
          <a
            v-for="(item, index) in list"
            :key="index"
            class="flex cp dynamic jc-sb"
            v-if="index > 3"
          >
            <div class="left ellipsis color-gray-10 fz16 ta-left">
              {{ item.schoolPageInfo.title }}
            </div>
            <div class="fz14 color-gray-7">
              {{
                item.schoolPageInfo.createTime
                  ? item.schoolPageInfo.createTime.split(" ")[0]
                  : ""
              }}
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: { info: Object },
  data() {
    return {
      list: [],
    };
  },
  watch: {
    info: {
      handler() {
        this.initList();
      },
      deep: true,
    },
  },
  methods: {
    initList() {
      this.info.wxSchoolPageItemList.forEach((item) => {
        item.schoolPageInfo.content = item.schoolPageInfo.content
          .replace(/<[^<>]+>/g, "")
          .replace(/&nbsp;/gi, "")
          .replace(/\s/g, "");
      });
      this.list = this.info.wxSchoolPageItemList;
    },
  },
  mounted() {
    this.initList();
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 1200px;
  padding: 48px 0;
  text-align: center;
  h1 {
    font-size: 36px;
  }
  .box-content {
    width: 580px;
    padding: 20px 20px 10px 20px;
    margin: 0 10px;
    box-sizing: border-box;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    height: 566px;
  }
  .more {
    color: #8c8c8c;
  }
  img {
    width: 160px;
    height: 100px;
    margin-right: 20px;
  }
  .color-gray-7 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
  .dynamic {
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    padding-bottom: 12px;
    margin-bottom: 16px;
    border-bottom: 1px dashed #d9d9d9;
    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
    }
    .left {
      width: 400px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/template/propaganda/propaganda2/index.vue